import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../components/footer/Footer';
import '../scss/component/_how-to-use.scss';

const UsingEkival = () => {
  const { t } = useTranslation();

  const stepsData = [
    {
      title: t('Connect Your Wallet'),
      description: t('Link your Cardano wallet to get started.'),
      icon: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
    },
    {
      title: t('Fund Your Wallet'),
      description: t('Ensure you have sufficient ADA in your wallet.'),
      icon: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'
    },
    {
      title: t('Initiate an Offer'),
      description: t('Create a new offer with your desired exchange rate.'),
      icon: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z'
    },
    {
      title: t('Accept an Order'),
      description: t('Browse and accept available orders that match your needs.'),
      icon: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'
    },
    {
      title: t('Track/Change Status'),
      description: t('Monitor your transaction progress in real-time.'),
      icon: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z'
    },
    {
      title: t('Complete Transaction'),
      description: t('The smart contract will allocate the funds, minus fees.'),
      icon: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'
    }
  ];

  return (
    <div className="wrapper">
      <section className="how-to-use">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>{t('Guide to Money Transfer')}</span>
                </h6>
                <h3 className="heading">
                  {t('How to Send Money')} <br />
                  {t('Using Ekival')}
                </h3>
                <p className="mt-20">
                  {t('Follow these simple steps to securely transfer money using our platform')}
                </p>
              </div>
              <div className="steps-section">
                {stepsData.map((step, index) => (
                  <div key={index} className="step-item">
                    <div className="step-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d={step.icon} fill="currentColor"/>
                      </svg>
                    </div>
                    <div className="step-content">
                      <div className="step-number">{index + 1}</div>
                      <h4>{step.title}</h4>
                      <p>{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default UsingEkival;